import { access } from 'fs';
import { authApi, svcApi } from '.';
import { green } from '@mui/material/colors';

interface loginParam {
  url: string;
  token?: string;
}

interface loginTokenParam {
  url: string;
  email: string;
  password: string;
}

interface submitParam {
  url: string;
  userId: string;
  serviceId: string;
  groupId?: string;
}

const UserApi = {
  Login: async (reqParam: loginParam) => {
    //백엔드에서 사용자 정보 요청
    console.log(reqParam.token);

    const result = await svcApi.post(
      reqParam.url,
      {},
      {
        headers: {
          token: `${reqParam.token}`,
        },
      },
    );

    return result;
  },
  IdLogin: async (username: string, password: string) => {
    const result = await svcApi.post(
      'auth/login',
      { username: username, password: password },
      { withCredentials: true },
    );

    return result;
  },
  FetchUserData: async (userId: string) => {
    const result = await svcApi.get('check/validate/id', { params: { userId: userId } });

    return result;
  },
  ValidateToken: async (url: string) => {
    const result = await svcApi.get(url, {
      withCredentials: true,
    });

    return result;
  },
  UserInfoToken: async (url: string) => {
    const result = await svcApi.get(url, {
      withCredentials: true,
    });

    return result;
  },
  LoginToken: async (reqParam: loginTokenParam) => {
    //로그인 서버에서 토큰 발급

    const result = await authApi.post(reqParam.url, {
      email: reqParam.email,
      password: reqParam.password,
    });

    return result;
  },
  //임시 사용자등록
  SignIn: async (url: string) => {
    const result = await authApi.post(url, {
      email: 'cropsuser',
      password: 'cropsuser',
    });

    return result;
  },

  Logout: async (reqParam: loginParam) => {
    const result = await svcApi.post(
      reqParam.url,
      {},
      {
        withCredentials: true,
      },
    );

    return result;
  },
  SUBMIT: async (reqParam: submitParam) => {
    const result = await svcApi.post(reqParam.url, {
      serviceId: reqParam.serviceId,
      userId: reqParam.userId,
      groupId: reqParam.groupId,
    });

    return result;
  },
  CarGroup: async () => {
    const result = await svcApi.get('/user/group/list', { params: { serviceId: 'VEHICLE' } });

    return result.data;
  },
  UpdatePassword: async (url: string, password: string, currentPassword: string) => {
    // try {
      const result = await svcApi.post(
        url || '/auth/update/password',
        {
          password,
          current_password: currentPassword,
        },
      );
      console.log(result.data);
      return result.data;
    // } catch (err: any) {
    //   return err?.response?.data;
    // }
  },
};

export default UserApi;
